import apiHttpClient from "./ApiHttpClient";

export default class ChapterVideoLogRepository {
  /**
   * startLogging
   * @param {int} chapterId
   * @param {int} slideId
   * @returns {Object}
   */
  async startLogging(chapterId) {
    try {
      const res = await apiHttpClient.post(`/chapter/${chapterId}/v/start`);
      return res.data;
    } catch (error) {
      throw error;
    }
  }

  /**
   * sendLog
   * @param {int} chapterId
   * @param {object} params
   * @returns {Object}
   */
  async sendLog(chapterId, params) {
    try {
      const res = await apiHttpClient.post(
        `/chapter/${chapterId}/v/timeupdate`,
        {
          id: params.id,
          history: params.history,
          watchedRanges: params.watchedRanges,
          watchedTimes: params.watchedTimes,
        }
      );
      return res.data;
    } catch (error) {
      throw error;
    }
  }
}
